/**
 * 国际化 (i18n) 配置
 * 
 * 支持语言:
 * - 简体中文 (zh_CN)
 * - 英文 (en_US)
 * 
 * 特性:
 * - 自动检测浏览器语言
 * - 用户选择的语言保存到 localStorage
 * - 类型安全的消息定义
 */
import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

/** 放宽 i18n 类型约束，避免中英文文案字面量冲突 */
declare module 'vue-i18n' {
  export interface DefineLocaleMessage extends Record<string, unknown> {}
}

/**
 * 优先级: localStorage > 浏览器语言 > 中文
 * 默认英文
 */
const getDefaultLanguage = (): string => {
  // const saved = localStorage.getItem('app_language')?.replace('-', '_')
  // const savedSource = localStorage.getItem('app_language_source')
  // 如果语言由用户选择且值有效，则优先使用该语言
  // }

  // const browserLanguages = navigator.languages?.length
  //   ? navigator.languages
  //   : [navigator.language]

  // 遍历浏览器语言列表
  //   const normalized = String(lang || '').toLowerCase()
  //   如果 normalized.startsWith('en')，则返回 'en_US'
  //   如果 normalized.startsWith('zh')，则返回 'zh_CN'
  // }

  return 'en_US'
}

const i18n = createI18n({
  legacy: false,
  locale: getDefaultLanguage(),
  fallbackLocale: 'en_US',
  messages: {
    zh_CN: zhCN,
    en_US: enUS,
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

export default i18n
